<template>
  <div name="FeatureList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">精選影音</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item active">精選影音</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->
    <!-- Main content -->
    <div id="Feature" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button
                type="info"
                :class="{ current: -1 == filterParams.categoryId }"
                @click="selectByType($event, -1, 0)"
                >全部</el-button
              >
              <el-button
                type="info"
                @click="selectByType($event, index, category.typeId)"
                v-for="(category, index) in categoryList"
                :class="{ current: index == filterParams.categoryId }"
                v-bind:key="category.Id"
                >{{ category.name }}</el-button
              >
            </div>
          </div>
          <div class="col-sm-2">
            <el-button size="primary" @click="IsAddFeature = true">
              <i class="nav-icon fas fa-cloud-upload-alt mr-1"></i>新增精選影音
            </el-button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs">
                <el-input
                  class="col-lg-2"
                  placeholder="搜尋精選影音"
                  v-model="filterParams.activeSearch"
                ></el-input>
                <!-- <el-input class="col-lg-2" placeholder="搜尋上傳者" v-model="filterParams.authorSearch"></el-input> -->
              </div>
              <div class="card-body">
                <el-table
                  :data="filterFeatureList"
                  border
                  :default-sort="{ prop: 'date' }"
                  v-loading="isload"
                >
                  <el-table-column label="精選影音" sortable width="510">
                    <template slot-scope="scope">
                      <div class="b-video-block mr-2 clearfix">
                        <div class="b-video-thumbnail">
                          <div class="b-video-responsive">
                            <div class="b-video-sizer">
                              <div
                                class="b-video-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${scope.row.imageFileP}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                          <div class="b-duration">
                            <span>{{ scope.row.mov_VSourceTimeFormat }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        <router-link
                        target="_blank"
                          :to="{
                            name: 'WatchVideo',
                            params: { id: scope.row.id, itemtype: 'video' },
                          }"
                          >{{ scope.row.sgL_Mov_VSubject }}</router-link
                        >
                      </span>

                      <span
                        class="b-tag"
                        v-if="scope.row.sgL_Mov_VKeyword != null"
                      >
                        <a
                          v-for="words in scope.row.sgL_Mov_VKeyword.split(',')"
                          v-bind:key="words"
                          >{{ words }}</a
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sgL_MasterSortName"
                    sortable
                    label="類別"
                    width="140"
                  ></el-table-column>
                  <el-table-column sortable label="狀態" width="140">
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.sgL_IsShow == true"
                        class="b-published"
                        >顯示中</span
                      >
                      <span v-else class="b-unpublished">隱藏中</span>
                      <!-- unpublished -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sgL_ExquisiteCreateTimeF"
                    sortable
                    label="加入精選日期"
                    width="160"
                  ></el-table-column>
                  <el-table-column
                    prop="SGL_Mov_VViewQuantity"
                    sortable
                    label="影片瀏覽量"
                    width="156"
                  ></el-table-column>
                  <el-table-column
                    prop="SGL_ExquisiteCount"
                    sortable
                    label="自精選點擊量"
                    width="160"
                  ></el-table-column>
                  <el-table-column
                    prop="content"
                    sortable
                    label="轉化率"
                    width="100"
                  ></el-table-column>
                  <el-table-column label="操作" width="240">
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="
                          open(
                            $event,
                            scope.row.id,
                            `您確定將影片[${scope.row.sgL_Mov_VSubject}]從影音精選中移出？`,
                            '移除精選',
                            'removeFeatured'
                          )
                        "
                        >移除精選</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="
                          updatefeature(scope.row.id, scope.row.sgL_IsShow)
                        "
                        v-if="scope.row.sgL_IsShow == true"
                        >設為隱藏</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        v-else
                        @click="
                          updatefeature(scope.row.id, scope.row.sgL_IsShow)
                        "
                        >設為顯示</el-button
                      >
                      <!-- <el-button
                        type="primary"
                        size="mini"
                        @click="open($event,scope.row.id,`您確定將影片[${scope.row.sgL_Mov_VSubject}]關聯？`,'關聯賽事')"
                      >编辑</el-button>-->
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <el-pagination background layout="prev, pager, next" :total="1000" :page-sizes="[10,11,12]"></el-pagination> -->
              </div>
              <div class="row">
                <div class="col-lg-3 offset-lg-8">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>

          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
        <el-dialog title="新增/編輯精選影音" :visible.sync="IsAddFeature">
          <el-form
            :model="featureModel"
            label-width="120px"
            ref="featureModel"
            :rules="featurerules"
          >
            <el-form-item label="精選影音類型" prop="featureType">
              <el-select
                v-model="featureModel.featureType"
                @change="changeType"
              >
                <el-option
                  v-for="op in featureTypeList"
                  :label="op.value"
                  :value="op.id"
                  :key="op.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="影音名稱" prop="featureId">
              <el-select v-model="featureModel.featureId" clearable>
                <el-option
                  v-for="op in GetvideoOrTvList"
                  :label="op.sgL_Mov_VSubject"
                  :value="op.id"
                  :key="op.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="IsAddFeature = false">取 消</el-button>
            <el-button type="primary" @click="AddFeature()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- /.Container Fluid -->
    </div>
  </div>
</template>
<!-- DataTables --> 
<!-- page script --> 
<script>
import { mapState, mapGetters, mapMutations, mapAction } from "vuex";
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  name: "FeatureList",
  data() {
    return {
      isload: true,
      curretncss: "current",
      FeatureList: [],
      videoOrTvList: [], //根据typeid查所有影片列表，下拉框用到
      featureTypeList: [
        { id: "256", value: "Soonnet TV" },
        { id: "0", value: "一般影片" },
      ],
      featureModel: {
        featureType: null, //一般影片ortv
        featuretitle: "",
        featureId: null,
      }, //添加精選模型
      IsAddFeature: false, //是否打開新增窗口
      categoryList: [
        { typeId: 1, name: "目前顯示中" },
        { typeId: 2, name: "過往精選節目" },
      ],
      featurerules: {
        featureType: [
          { required: true, message: "請選擇影音類型", triggle: "blur" },
        ],
      },

      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageshow: true,
      },
      //查询参数
      filterParams: {
        authorSearch: "",
        activeSearch: "",
        categoryId: -1, //记录当前选中的类型
        typeId: 0, //type为0为查询全部
      },
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  created() {
    this.FeatureType = this.$route.params.FeatureType; //获取路由参数
    this.GetFeatureList();
  },
  mounted() {},
  watch: {
    "filterParams.activeSearch": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    "filterParams.authorSearch": {
      handler: function (newval, oldval) {
        this.ByfilterTvList();
      },
    },
    FeatureList(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.isload = false;
      }
    },
  },
  methods: {
    async GetFeatureList() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        Title: this.filterParams.activeSearch,
        quserName: this.filterParams.authorSearch,
        SGL_IsShow: this.filterParams.typeId,
      };
      this.$api.VideoApi.GetAdminExquisite(params).then((res) => {
        this.FeatureList = res.data.result.items;
        this.pageParams.total = res.data.result.totalCount;
        if (this.FeatureList.length <= 0) {
          this.isload = false;
        }
      });
    },
    //按条件查询
    ByfilterTvList() {
      this.handleCurrentChange(1);
    },
    changeType(TId) {
      this.videoOrTvList.length = 0;
      this.featureModel.featuretitle = "";
      let param = {
        SGL_Moive_TypeId: TId,
        Sorting: "1",
        sGL_IsPublic: 1,
        SkipCount: 0,
        MaxResultCount: 50,
      };
      this.$api.VideoApi.AdminVideoList(param).then((result) => {
        this.videoOrTvList = result.data.result.items;
      });
    },
    //上传tv点击方法
    uploadTV() {
      //跳转组件
      this.$router.push({ path: "/Backstage/uploadTV" });
    },
    //打开模态框
    open(e, Id, operator, title, method) {
      // this.$refs.featureModel.resetFields(); //清空表单
      this.$confirm(operator, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (method == "removeFeatured") {
            await this.Choice(Id, method);
          } else if (method == "deleteTv") {
            await this.DeleteTv(Id);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
    //根据分类查询数据
    selectByType(e, index, typeId) {
      this.filterParams.typeId = typeId;
      this.filterParams.categoryId = index;
      //追加选中的样式
      if (index > 0) {
        this.curretncss = "";
      } else {
        this.curretncss = "current";
      }
      this.handleCurrentChange(1);
    },
    updatefeature(id, state) {
      let params = { id: id, sgL_IsShow: !state };
      this.$api.VideoApi.updateAdminexquiste(params).then((res) => {
        if (res.data.success) {
          this.GetFeatureList();
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    //加入精选与移除精选
    Choice(Id, method) {
      //调用移除精选的方法
      let params = {
        sgL_Moive_Id: Id,
      };
      this.$api.VideoApi.removeAdminExquisite(params).then((result) => {
        if (result.data.success == true) {
          this.GetFeatureList();
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          this.$message({
            type: "warning",
            message: result.data.error.message,
          });
        }
      });
    },
    //删除
    DeleteTv(Id) {
      this.$api.VideoApi.DeleteTv(Id).then((result) => {
        if (result.data.success == "true") {
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "warning",
            message: "刪除失敗",
          });
        }
      });
    },
    AddFeature() {
      this.IsAddFeature = true;
      //调用移除精选的方法
      let params = {
        sgL_Moive_Id: this.featureModel.featureId,
      };
      this.$api.VideoApi.AddAdminExquisite(params).then((result) => {
        if (result.data.success == true) {
          this.IsAddFeature = false;
          // this.$refs.featureModel.resetFields(); //清空表单
          this.GetFeatureList();
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          this.$message({
            type: "warning",
            message: result.data.error.message,
          });
        }
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetFeatureList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetFeatureList();
    },
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  computed: {
    //查询方法
    filterFeatureList() {
      return this.FeatureList;
    },
    GetvideoOrTvList() {
      return this.videoOrTvList;
    },
  },
  components: {
    pagination,
  },
};
$(function () {
  $(".video--upload---success").click(function () {
    Message({
      message: "影片上傳成功",
      type: "success",
      showClose: false,
      timeout: 600,
      callback: () => {
        //router.go(-1);
      },
    });
  });
  $(".video--edit---success").click(function () {
    Message({
      message: "影片已修改成功",
      type: "success",
    });
  });
  $(".video--remove---success").click(function () {
    Message({
      message: "影片已刪除",
      type: "success",
    });
  });
  $(".featured--add---success").click(function () {
    Message({
      message: "影片已新增至影音精選",
      type: "success",
    });
  });
  $(".featured--remove---success").click(function () {
    Message({
      message: "影片已從影音精選中移除",
      type: "success",
    });
  });
  $(".related--add---success").click(function () {
    Message({
      message: "影片已與賽事關聯成功",
      type: "success",
    });
  });
  $(".related--remove---success").click(function () {
    Message({
      message: "影片已與賽事已取消關聯",
      type: "success",
    });
  });
});
</script>
<style scoped>
.margs {
  margin: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminVideo/FeatureList.vue